import { updateBrand } from "@irati/ui/src/global/theme";
export default (function (tenant) { return updateBrand(tenant); });
